import {
  ChangeDetectionStrategy,
  Component,
  Input,
  forwardRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ControlValueAccessorConnector } from '../utils/control-value-accessor-connector/control-value-accessor-connector';

@Component({
  selector: 'stena-input',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StenaInputComponent),
      multi: true,
    },
  ],
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule],
  templateUrl: './stena-input.component.html',
  styleUrls: ['./stena-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StenaInputComponent extends ControlValueAccessorConnector {
  @Input() searchField = false;
  @Input() label = '';
  @Input() type: 'text' | 'number' | 'email' = 'text';
}
